import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';
import { DateHelper } from '../util/dateHelper';
import { Log } from '../util/log';


export class GetAccessesApi extends BaseModel implements Deserializable {

  deviceSerial: number;
  from: string;
  to: string;


  deserialize(input: any) {
    super.deserialize(input);
    Object.assign(this, input);
    Log.debug("GetAccessesApi :" + JSON.stringify(this));
    return this;
  }
}
